module.exports = __webpack_public_path__ + "img/image_6.3c57e171.jpg";